import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import translate from "@insite/client-framework/Translate";
import { OrderModel, OrderSettingsModel } from "@insite/client-framework/Types/ApiModels";
import SmallHeadingAndText, { SmallHeadingAndTextStyles } from "@insite/content-library/Components/SmallHeadingAndText";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import DataTableCell, { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import DataTableRow from "@insite/mobius/DataTable/DataTableRow";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import { GridItemProps } from "@insite/mobius/GridItem";
import getColor from "@insite/mobius/utilities/getColor";
import CustomSmallHeadingAndText from "@WhiteCap/Components/CustomSmallHeadingAndText";
import OrderDetailsKebabMenu from "@WhiteCap/Components/OrderDetailsKebabMenu";
import ProofOfDeliveryComponent from "@WhiteCap/Components/ProofOfDeliveryComponent";
import StatusLableAndHeading from "@WhiteCap/Components/StatusLableAndHeading";
import loadPODData from "@WhiteCap/Handlers/PODOrderHistory/PODHandler";
import CustomApplicationState from "@WhiteCap/Store/Data/CustomApplicationState/CustomApplicationState";
import WhitecapColors from "@WhiteCap/Utils/WhiteCapColor";

import React, { FC, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";


const mapStateToProps = (state: CustomApplicationState) => ({
    language: state.context.session.language,
    isLoading: state.WhiteCap.podDataStore.isLoading,

});
const mapDispatchToProps = {
    loadPODData,
};
interface OwnProps {
    order: OrderModel;
    indexNumber: number;
    orderSettings: OrderSettingsModel;
    extendedStyles?: OrderSummaryCardStyles;
}

type Props = ReturnType<typeof mapStateToProps> & ResolveThunks<typeof mapDispatchToProps> & OwnProps;

export interface OrderSummaryCardStyles {
    orderSummaryCardGridItem?: GridItemProps;
    container?: GridContainerProps;
    pageTypeLinkGridItem?: GridItemProps;
    orderNumberGridItem?: GridItemProps;
    orderNumberHeadingAndText?: SmallHeadingAndTextStyles;
    statusGridItem?: GridItemProps;
    statusHeadingAndText?: SmallHeadingAndTextStyles;
    webOrderNumberGridItem?: GridItemProps;
    webOrderNumberHeadingAndText?: SmallHeadingAndTextStyles;
    totalGridItem?: GridItemProps;
    totalHeadingAndText?: SmallHeadingAndTextStyles;
    orderDateHeader?: DataTableHeaderProps;
    orderNumberHeader?: DataTableHeaderProps;
    shipToHeader?: DataTableHeaderProps;
    statusHeader?: DataTableHeaderProps;
    customerPOHeader?: DataTableHeaderProps;
    orderTotalHeader?: DataTableHeaderProps;
    reorderHeader?: DataTableHeaderProps;
    orderDateCells?: DataTableCellProps;
    orderNumberCells?: DataTableCellProps;
    shipToCells?: DataTableCellProps;
    kababMenu?:DataTableCellProps;
    statusCells?: DataTableCellProps;
    customerPOCells?: DataTableCellProps;
    orderTotalCells?: DataTableCellProps;
    orderPoCells?: DataTableCellProps;
    reorderCells?: DataTableCellProps;
    trackButton?: ButtonPresentationProps;
}

export const orderSummaryCardStyles: OrderSummaryCardStyles = {
    orderSummaryCardGridItem: {
        width: 12,
        css: css`
            padding: 0 20px;
            max-width: 500px;
        `,
    },
    trackButton:{
        css:css`
        font-size: 14px !important;
        padding-left: 4px;
        padding-right: 4px;
        font-weight: 500 !important; 
        `,
    },
    container: { gap: 5 },
    pageTypeLinkGridItem: { width: 12 },
    orderNumberGridItem: { width: 6 },
    statusGridItem: { width: 6 },
    webOrderNumberGridItem: { width: 6 },
    totalGridItem: { width: 6 },
    kababMenu:{
    /* WCC - EC-750 My Account Dashboard */
    css:css`
        text-align:right;
        padding: 0px;
        width: 5%;
    `,
},
/* WCC - EC-750 My Account Dashboard */
orderTotalCells:{
    css:css`
        width: 15%;
        padding: 0px;
        p[data-test-selector^="heading"]{
            text-align:right;
        }
        p[data-test-selector^="text_Total"]{
            text-align:right;
        }
    `,
},
orderPoCells:{
    css: css`
        width: 27%;
    `
},
orderNumberCells:{
css:css`
width:20%;
padding: 0 10px;
`,
},
orderDateCells:{
css:css`
width:20%;
padding: 0 10px;
`,
},
shipToCells:{
    css:css`
    width:33%;
    padding: 0 6px;
    > div{
        align-items: flex-end;
    }
    `,
},


    orderNumberHeadingAndText:{
heading:{
    css:css`
    color:  ${WhitecapColors.iconColor};
text-align: center;
font-weight:400;
font-size: 14px;
    `
},

text:{
    css:css`
     color: ${WhitecapColors.iconColor}; 
font-size: 16px;
text-align: center;
font-weight: 450;
    `
}
    }

};

const OrderSummaryCardMobile: FC<Props> = ({ language, order, orderSettings,isLoading,indexNumber, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(orderSummaryCardStyles, extendedStyles));
    const [PODstate, setPODState] = useState({
        isModalOpen: false,
        selectedIndex: 0,
        poNumber: "",
    });
    const isTrueOrUndefined = (value?: boolean) => value === true || value === undefined;

    const trackHandler = (url: string | URL | undefined) => {
        if (!url) {
            return;
        }

        try {
            const parsedUrl = new URL(url, window.location.origin);

            if (parsedUrl.protocol !== "http:" && parsedUrl.protocol !== "https:") {
                return;
            }

            window.open(parsedUrl.toString(), "_blank", "noopener,noreferrer");
        } catch {
            return;
        }
    }

    const orderDateDisplay = getLocalizedDateTime({
        dateTime: order.orderDate,
        language,
        options: {
            year: "numeric",
            month: "numeric",
            day: "numeric",
        },
    });
    const orderNumber = order.erpOrderNumber || order.webOrderNumber;
    const loadPODDataHandler = (id: string, properties: any, arrayindex: number, po: string) => {
        setPODState({
            isModalOpen: true,
            selectedIndex: arrayindex,
            poNumber: po,
        });

        loadPODData({ orderNumber: id, id: properties.podId });
    };
    const closeModal = () => {
        setPODState({ 
            isModalOpen: false,
            selectedIndex: 0,
            poNumber: ''
        });
    };
    return (
        <>
        <DataTableRow css={css`border-bottom: 1px solid ${getColor("common.border")};
 `}>
        <StyledWrapper css={css`width:100%; td{border-bottom:none;}`}>

            <DataTableCell
                {...styles.orderDateCells}
                data-test-selector="orderHistoryTable_tableCell_date"
            >
                {(order.erpOrderNumber || order.webOrderNumber) && (
                    <CustomSmallHeadingAndText
                        // eslint-disable-next-line spire/avoid-dynamic-translate
                        heading={translate("ORDER #")}
                        text={order.erpOrderNumber !== "" ? order.erpOrderNumber : order.webOrderNumber}
                        extendedStyles={styles.orderNumberHeadingAndText}
                    />)}

            </DataTableCell>

            <DataTableCell
                {...styles.orderNumberCells}
                data-test-selector="orderHistoryTable_tableCell_orderNumber"
            >                {order.orderDate && (
                <SmallHeadingAndText
                    heading={translate("ORDER DATE")}
                    text={order.orderDate
                    ? getLocalizedDateTime({
                          dateTime: new Date(order.orderDate),
                          language,
                      })
                    : ""}
                    extendedStyles={styles.orderNumberHeadingAndText}
                />)}

            </DataTableCell>

            {/* <DataTableCell  {...styles.orderDateCells}>{order.properties?.orderLinesCount && (
                <SmallHeadingAndText
                    heading={translate("Items")}
                    text={order.properties?.orderLinesCount}
                    extendedStyles={styles.orderNumberHeadingAndText}
                />
            )}</DataTableCell> */}

            <DataTableCell {...styles.orderTotalCells}>{order.orderGrandTotalDisplay && (
                <SmallHeadingAndText
                    heading={translate("Total")}
                    text={order.orderGrandTotalDisplay}
                    extendedStyles={styles.orderNumberHeadingAndText}
                />
            )}</DataTableCell>

            {/* { WCC-EC -750 - Customer PO Added for Orser Summary} */}
            <DataTableCell {...styles.orderPoCells}>
                {order.customerPO && (
                    <SmallHeadingAndText
                        heading={translate("PO #")}
                        text={order.customerPO}
                        extendedStyles={styles.orderNumberHeadingAndText}
                    />
                )}
            </DataTableCell>

            <DataTableCell {...styles.kababMenu} align="right">
                <OrderDetailsKebabMenu orderNumber={order.erpOrderNumber} />
            </DataTableCell>
            </StyledWrapper>

            <StyledWrapper css={css`width:100%; td{border-bottom:none;}`}>
                {/* { WCC-EC -750 - Removed Ship Via and POD from Dashboard} */}

                {/* <DataTableCell css={css`width:33%;     padding: 0 10px;`}>
                        {order.properties?.shipViaDescription && (
                    <SmallHeadingAndTextDelivery
                        heading={translate("Delivery")}
                        text={translate("{0}",`${order.properties?.isMultipleShipment?.toString() === "true" ?  order.properties?.noOfShipmentPackages : order.properties?.shipViaDescription}`)}
                        extendedStyles={styles.orderNumberHeadingAndText}
                    />
                )}
                </DataTableCell>
                <DataTableCell {...styles.shipToCells}>
                    {order.properties.hasPod.toLocaleLowerCase() === "true" && order.properties?.isMultipleShipment?.toString() !== "true" ? (
                        <Clickable
                            onClick={() => {
                                loadPODDataHandler(order.id, order.properties, indexNumber, order.customerPO);
                            }}
                        >
                            POD
                        </Clickable>
                    ) : (<>
                    {order.properties?.trackingURLs && order.properties?.isMultipleShipment?.toString() !== "true" && <Button variant="secondary" {...styles.trackButton} onClick={() => trackHandler(order.properties?.trackingURLs)}>{translate("Track")}</Button>}
                    </>) }
                </DataTableCell>  */}

                 {/* { WCC-EC -750 - Added Status in My Account Dashboard} */}
                <DataTableCell
                    {...styles.shipToCells}
                    data-test-selector="orderHistoryTable_tableCell_status"
                >
                        {order?.statusDisplay &&<StatusLableAndHeading
                            heading={translate("Status")}
                            // isTrue={order.properties?.isMultipleShipment?.toString() === "true"}
                            text={order.statusDisplay}
                            extendedStyles={styles.orderNumberHeadingAndText}
                        />}
                </DataTableCell>
            </StyledWrapper>
        </DataTableRow>
        {!isLoading ? (
            <ProofOfDeliveryComponent
                onHandleClose={closeModal}
                modalIsOpen={PODstate.isModalOpen}
                poNumber={PODstate.poNumber}                  
            />
        ) : null}
        </>
       


    );
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderSummaryCardMobile);
